import React, { useState, useEffect } from 'react';
import { Container, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import './Hero.css';
import pdf from '../../assets/whitepaper.pdf';
import { FaChevronDown } from 'react-icons/fa';

import bsc from '../../assets/images/chains/binance.svg';
import polygon from '../../assets/images/chains/polygon.svg';
import avalanche from '../../assets/images/chains/avalanche.svg';
import arbitrum from '../../assets/images/chains/arbitrum.png';
import sonic from '../../assets/images/chains/sonic.png';
import base from '../../assets/images/chains/base.png';

export default function Hero() {
  const [activeNetwork, setActiveNetwork] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [showComingSoon, setShowComingSoon] = useState(false);

  const scrollToContent = () => {
    const solutionsSection = document.getElementById('solutions');
    if (solutionsSection) {
      solutionsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleComingSoon = () => setShowComingSoon(true);
  const closeComingSoon = () => setShowComingSoon(false);

  // Handle parallax effect on scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Add typing animation to title effect when component mounts
  useEffect(() => {
    const titleElement = document.querySelector('.hero-title');
    if (titleElement) {
      titleElement.classList.add('animate-title');
      // Add typing animation class
      setTimeout(() => {
        titleElement.classList.add('typing-animation');
      }, 500);
    }
  }, []);

  const handleNetworkHover = (network) => {
    setActiveNetwork(network);
  };

  const networks = [
    { id: 'sonic', name: 'Sonic', img: sonic },
    { id: 'binance', name: 'BNB', img: bsc },
    { id: 'arbitrum', name: 'Arbitrum', img: arbitrum },
    { id: 'base', name: 'Base', img: base },
    { id: 'polygon', name: 'Polygon', img: polygon },
    { id: 'avalanche', name: 'Avalanche C-Chain', img: avalanche },
  ];

  return (
    <div className="hero-section">
      <div
        className="hero-background"
        style={{ transform: `translateY(${scrollPosition * 0.15}px)` }}
      ></div>

      <Container>
        <div className="hero-content">
          <h1 className="hero-title">MCGPChain</h1>
          <p className="hero-tagline">
            Revolutionizing Real Estate, Agriculture, and Real World Assets
            through blockchain.
          </p>
          <div className="hero-subtitle">
            <h2>Empowering Growth with $MCGP</h2>
            <p>
              The $MCGP Tokenization Ecosystem lowers barriers to investment,
              enabling fractional ownership, greater liquidity, and portfolio
              diversification. By democratizing access to high-value assets, it
              creates a more inclusive, transparent, and secure financial
              future.
            </p>
            <p className="hero-description">
              MCGPChain is your gateway to the future of digital finance—secure,
              accessible, and built for real-world impact.
            </p>
          </div>
          <div className="hero-actions">
            <Button
              className="btn-primary action-button pulse-animation"
              onClick={handleComingSoon}
            >
              Buy $MCGP
            </Button>
            {showComingSoon && (
              <div className="coming-soon-modal" 
                style={{
                  position: 'fixed', 
                  top: 0, 
                  left: 0, 
                  right: 0, 
                  bottom: 0, 
                  background: 'rgba(0,0,0,0.75)', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  zIndex: 1000,
                  backdropFilter: 'blur(5px)',
                  animation: 'fadeIn 0.3s ease-in-out'
                }}>
                <div 
                  style={{
                    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                    padding: '2.5rem 3.5rem',
                    borderRadius: '15px',
                    textAlign: 'center',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    color: '#fff',
                    maxWidth: '450px',
                    width: '90%',
                    animation: 'slideUp 0.4s ease-out',
                    position: 'relative'
                  }}>
                  <h2 style={{
                    fontSize: '28px', 
                    marginBottom: '15px',
                    fontWeight: '700',
                    background: 'linear-gradient(90deg, #7928CA, #FF0080)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                  }}>Coming Soon</h2>
                  <p style={{
                    fontSize: '16px',
                    lineHeight: '1.6',
                    marginBottom: '25px',
                    color: 'rgba(255, 255, 255, 0.85)'
                  }}>Buying $MCGP tokens will be available in the near future. Stay tuned for the official launch!</p>
                  <button 
                    onClick={closeComingSoon} 
                    style={{
                      padding: '0.75rem 2rem',
                      border: 'none',
                      background: 'linear-gradient(90deg, #7928CA, #FF0080)',
                      color: '#fff',
                      borderRadius: '30px',
                      cursor: 'pointer',
                      fontWeight: '600',
                      fontSize: '16px',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 15px rgba(121, 40, 202, 0.4)'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 7px 20px rgba(121, 40, 202, 0.5)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(121, 40, 202, 0.4)';
                    }}
                  >
                    I&apos;ll Be Back
                  </button>
                </div>
              </div>
            )}
            <Link
              to={pdf}
              target="_blank"
              className="btn btn-outline action-button hover-float"
            >
              Whitepaper
            </Link>
          </div>

          <button className="scroll-down-btn" onClick={scrollToContent}>
            <span>Explore</span>
            <FaChevronDown className="chevron-icon" />
          </button>
        </div>
      </Container>

      <div className="evm-network-slider">
        <div className="slider-heading">
          <span>EVM Supported Networks</span>
          {activeNetwork && (
            <div className="network-info-tooltip">
              {activeNetwork} network supported
            </div>
          )}
        </div>
        <div className="slider-container">
          <div className="slider-track interactive-track">
            {/* Network logos */}
            {networks.map((network) => (
              <div
                key={network.id}
                className="chain-logo interactive"
                onMouseEnter={() => handleNetworkHover(network.name)}
                onMouseLeave={() => handleNetworkHover(null)}
              >
                <img src={network.img} alt={network.name} className="mr-1" />{' '}
                {network.name}
              </div>
            ))}

            {/* Duplicate for infinite effect */}
            {networks.map((network) => (
              <div
                key={`dup-${network.id}`}
                className="chain-logo interactive"
                onMouseEnter={() => handleNetworkHover(network.name)}
                onMouseLeave={() => handleNetworkHover(null)}
              >
                <img src={network.img} alt={network.name} className="mr-1" />{' '}
                {network.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
